import React, { useContext } from 'react';
import {
  Formik, Form, Field, useFormikContext,
} from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { InputTextComponent, TextAreaComponent, FormikCheckbox } from '../../../components/prime-formik';
import { AccountContext } from '../../../components/AccountContext';

const i18nMessages = defineMessages({
  libraryCode: {
    id: 'menu.item-bank-management.library-code',
    defaultMessage: 'Library Code',
  },
  libraryDisplayName: {
    id: 'menu.item-bank-management.library-display-name',
    defaultMessage: 'Library Code',
  },
  libraryDescription: {
    id: 'menu.item-bank-management.library-description',
    defaultMessage: 'Library Description',
  },
  private: {
    id: 'menu.item-bank-management.private',
    defaultMessage: 'Private',
  },
});

const AddSurveyLibrary = () => {
  const currentAccount = useContext(AccountContext);
  const { formatMessage } = useIntl();
  const history = useHistory();
  const {
    setFieldValue,
    values: { library },
  } = useFormikContext();

  const initialValues = {
    code: library ? library.code : '',
    displayName: library ? library.displayName : '',
    description: library ? library.description : '',
    isPrivate: library ? library.isPrivate : false,
  };

  const validationSchema = Yup.object({});

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.resetForm();

        setFieldValue('library', { ...values });

        history.push(`/accounts/${currentAccount}/add-itembank-survey-content/new/add-competency`);
      }}
      render={({ handleSubmit, setFieldValue: setInnerFormFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <div className="dimension-basic-data-form-controls">
            <div>
              <div className="input-label">{formatMessage(i18nMessages.libraryCode)}</div>
              <div>
                <Field id="code" name="code" component={InputTextComponent} />
              </div>
            </div>
            <div>
              <div className="input-label">{formatMessage(i18nMessages.libraryDisplayName)}</div>
              <div>
                <Field id="displayName" name="displayName" component={InputTextComponent} />
              </div>
            </div>
            <div>
              <div className="input-label">{formatMessage(i18nMessages.libraryDescription)}</div>
              <div>
                <Field id="description" name="description" component={TextAreaComponent} />
              </div>
            </div>
          </div>
          <div className="behavior-distortion-controls">
            <strong className="input-label distortion">{formatMessage(i18nMessages.private)}</strong>
            <span>
              <Field
                id="isPrivate"
                name="isPrivate"
                setFieldValue={setInnerFormFieldValue}
                component={FormikCheckbox}
              />
            </span>
          </div>

          <div>
            <FormattedMessage id="actions.save" defaultMessage="Save">
              {text => <Button type="submit" label={text} />}
            </FormattedMessage>
            <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
              {text => (
                <Button
                  type="button"
                  onClick={() => history.goBack()}
                  className="p-button-secondary"
                  label={text}
                />
              )}
            </FormattedMessage>
          </div>
        </Form>
      )}
    />
  );
};

export default AddSurveyLibrary;
